"use client";

import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import socketService from "../../../../utils/socket";
import { useDispatch, useSelector } from "react-redux";
import Image from "next/image";
import { convertTo24HourFormat, getExtensionImage, getFileTypeFromUrl } from "../../../../utils/common";
import { useSuggestionsQuery } from "../../../../Redux/apis/content";
import EmojiInput from "../../../Common/EmojiInput/EmojiInput";
import uploadFileToS3 from "../../../../utils/file.upload";
import ImageLoader from "@/Components/Common/ImageLoader/ImageLoader";
import AntiVirusScan from "@/Components/Common/AnitiVirusScan/AntiVirusScan";
import ChatImageAttachment, { ChatImagePreview } from "@/Components/Common/ChatImageAttachment";
import PreviewImagePopup from "../../../Common/PreviewImagePopup/PreviewImagePopup";
import AppointmentComponent from "../../../Common/AppointmentComponent/AppointmentComponent";
import { toast } from "react-toastify";
import { sendMessageDB } from "@/services/message";
import Avatar from "react-avatar";
import { sanitizeImageUrl } from "@/utils/imageUrl";
import { useSearchProductsByRepsIdQuery } from "@/Redux/apis/product";
import Spinner from "@/Components/Common/Spinner";
import { store } from "@/Redux/store/store";
import { addMessage } from "@/Redux/slice/chatSlice";
const SendMessage = ({
  name,
  onClose,
  isOpen,
  senderId,
  receiverId,
  product = null,
  suggestion = true,
  showPredefinedMessage = false
}) => {
  if (!isOpen) return null;
  console.log(senderId, receiverId, product, "PRODUCTS_LIST");
  const users = useSelector(state => state?.userData?.userData?.user);
  const chatMessages = useSelector(state_0 => state_0?.chat?.messages);
  console.log(chatMessages);
  const dispatch = useDispatch();
  const [activeChat, setActiveChat] = useState();
  const messages = useSelector(state_1 => {
    let chat = state_1?.chat?.messages?.filter(msg => msg.id === receiverId);
    return chat[0]?.messages;
  });
  useEffect(() => {
    const chat_0 = chatMessages?.find(msg_0 => msg_0.id === receiverId);
    console.log("CHATS_INDEX", chatMessages, receiverId);
    if (chat_0) {
      setActiveChat(chat_0);
    }
  }, [receiverId, chatMessages]);
  const [load, setLoad] = useState(false);
  const [message, setMessage] = useState("");
  const [suggestionsList, setSuggestionsList] = useState();
  const [showSuggestion, setShowSuggestion] = useState(true);
  const [fileUploadingLoader, setFileUploadingLoader] = useState(false);
  const [isAntiVirusScanOpen, setAntiVirusScam] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [isPreviewImageOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState();
  const [fileToDownload, setFileToDownload] = useState({
    file: "",
    fileName: ""
  });
  const openPreviewImage = image => {
    if (image) {
      setPreviewImage(image);
      setPreviewOpen(true);
    }
  };
  const closePreviewImage = () => {
    setPreviewImage(null);
    setPreviewOpen(false);
  };
  const openAntiVirusScanPopup = (file, fileName) => {
    setFileToDownload({
      file,
      fileName
    });
    setAntiVirusScam(true);
  };
  const closeAntiVirusScanPopup = () => {
    setFileToDownload({
      file: "",
      fileName: ""
    });
    setAntiVirusScam(false);
  };
  const suggestionsData = useSuggestionsQuery({}, {
    refetchOnMountOrArgChange: true,
    skip: !suggestion
  });
  useEffect(() => {
    if (!suggestionsData.isLoading) {
      setSuggestionsList(suggestionsData?.data ? suggestionsData?.data?.suggestions : []);
    } else if (suggestionsData?.isLoading) {}
  }, [suggestionsData?.data, suggestionsData?.isLoading, suggestionsData?.isError]);
  const handleInputChange = event => {
    setMessage(event.target.value);
  };
  const lastMessageRef = useRef(null);
  useEffect(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({
        behavior: "smooth"
      });
    }
  }, [messages]);
  const HandleUploadFiles = async () => {
    setFileUploadingLoader(true);
    try {
      const file_0 = selectedFile;
      const fileName_0 = file_0?.name;
      let fileUrl;
      if (file_0) {
        const validFileTypes = ["image/jpeg", "image/jpg", "image/png", "text/csv", "application/pdf", "text/plain", "application/msword",
        // for .doc files
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        // for .docx files
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"];
        if (!validFileTypes.includes(file_0?.type)) {
          toast.error("Invalid file type! Only JPG, JPEG, PNG, CSV, PDF, TXT, DOC, DOCX and PPTX files are allowed.");
          setFileUploadingLoader(false);
          return;
        }
        fileUrl = await uploadFileToS3({
          folder: "messages",
          file: file_0,
          setLoading: setFileUploadingLoader
        });
      }
      if (fileUrl?.length) {
        const msgResponse = await sendMessageDB({
          senderId,
          receiverId,
          profilePic: users?.profile,
          senderName: users?.firstName + " " + users.lastName,
          ...(getFileTypeFromUrl(fileUrl) === "image" ? {
            image: fileUrl,
            fileName: fileName_0
          } : {
            file: fileUrl,
            fileName: fileName_0
          }),
          createdAt: new Date().toISOString()
        });
        store.dispatch(addMessage({
          success: true,
          data: msgResponse?.data
        }));
        socketService.sendMessage(msgResponse);
        setSelectedFile(null);
      } else {
        toast.error("File upload failed!");
      }
      setFileUploadingLoader(false);
    } catch (error) {
      console.error("Error:", error);
      setFileUploadingLoader(false);
    }
  };
  const setMessageFromSuggest = text => {
    setMessage(text);
    setShowSuggestion(false);
  };
  const sendMessage = async e => {
    e.preventDefault();
    if (selectedFile) {
      HandleUploadFiles();
      return;
    }
    if (message.trim()) {
      let senderId_0 = users?._id;
      const msgResponse_0 = await sendMessageDB({
        senderId: senderId_0,
        receiverId,
        text: message,
        profilePic: users?.profile,
        senderName: users?.firstName + " " + users.lastName,
        ...(product ? {
          productId: product?.id,
          image: product?.image || "https://alph-md-storage.s3.us-east-2.amazonaws.com/products/pills.png"
        } : {}),
        createdAt: new Date().toISOString()
      });
      store.dispatch(addMessage({
        success: true,
        data: msgResponse_0?.data
      }));
      socketService.sendMessage(msgResponse_0);
    }
    setMessage("");
  };
  const handleSelectFile = event_0 => {
    setSelectedFile(event_0.target.files[0]);
  };

  // Portal to <body> so the popup escapes ancestor stacking contexts
  // and the dashboard navbar (z-[11]) can't bleed over the modal.
  // SSR guard is the cheap `typeof document` check — no useEffect
  // tick, so the modal renders on the very first frame after the
  // parent flips its state. (The mounted+useEffect pattern caused a
  // one-frame white flash between the rep popup unmounting and this
  // one mounting.)
  if (typeof document === "undefined") return null;
  const modal = <>
      <div className="fixed inset-0 popup-bg z-[9999] flex justify-center items-end sm:items-center">
        <div className="w-full sm:w-[607px] h-full sm:h-[560px] bg-white rounded-none sm:rounded-2xl shadow border border-neutral-200 flex flex-col overflow-hidden">
          {/* Header */}
          <div className="w-full flex justify-between items-center px-4 pt-4 pb-3 border-b border-neutral-200 flex-shrink-0">
            <div className="text-black text-sm sm:text-base font-semibold font-poppins truncate pr-2">
              Send a message to {activeChat?.firstName ? `${activeChat?.firstName} ${activeChat?.lastName}` : name}
            </div>
            <div onClick={onClose} className="w-6 h-6 cursor-pointer flex items-center justify-center hover:bg-gray-100 rounded-full flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M5.00073 17.5864C4.61023 17.977 4.61029 18.6101 5.00085 19.0006C5.39141 19.3911 6.02457 19.3911 6.41506 19.0005L12.0003 13.4143L17.586 19C17.9765 19.3905 18.6097 19.3905 19.0002 19C19.3907 18.6095 19.3907 17.9763 19.0002 17.5858L13.4144 12L18.9998 6.41359C19.3902 6.02303 19.3902 5.38987 18.9996 4.99938C18.6091 4.60888 17.9759 4.60894 17.5854 4.9995L12.0001 10.5858L6.41438 4.99998C6.02386 4.60946 5.39069 4.60946 5.00017 4.99998C4.60964 5.39051 4.60964 6.02367 5.00017 6.4142L10.5861 12.0001L5.00073 17.5864Z" fill="#8E8E8E" />
              </svg>
            </div>
          </div>

          {/* Scrollable Messages Area */}
          <div className="flex-1 flex flex-col w-full px-4 py-3 overflow-y-auto invisible-scrollbar">
              {messages?.map((message_0, index) => !message_0?.productId ? <div className={`pt-8 flex-col  gap-4 `} ref={index === messages?.length - 1 ? lastMessageRef : null}>
                    <div className={`flex ${message_0?.senderId !== users?._id ? "justify-start" : "justify-end"} flex-row gap-2 sm:gap-4`}>
                      {message_0?.senderId !== users?._id && <div className="w-[32px] h-[32px] sm:w-[40px] sm:h-[40px] rounded-lg flex-shrink-0">
                          {sanitizeImageUrl(activeChat?.profile || activeChat?.logo) ? <Image className={`cursor-pointer rounded-lg`} src={activeChat?.profile || activeChat?.logo} width={40} height={40} alt="profile" /> : <Avatar name={activeChat?.firstName} round={8} size={32} className="sm:!w-[40px] sm:!h-[40px]" />}
                        </div>}
                      <div className="flex-col justify-start items-start gap-2 inline-flex">
                        <div className={`px-4 py-2 ${message_0?.senderId !== users?._id ? "bg-[#EEEEEE]" : "bg-[#354EF0]"} rounded-xl justify-start items-start gap-2.5 inline-flex`}>
                          <div className={`${message_0?.senderId !== users?._id ? "text-[#1F1F1F]" : "text-white"} text-sm font-medium whitespace-pre-wrap font-poppins`}>
                            {!message_0?.appointmentId && message_0?.text}
                            {(message_0?.appointmentId || message_0?.requestedAppointmentId) && <AppointmentComponent message={message_0} appointment={message_0.appointmentId} users={users} activeChat={activeChat} />}
                            {message_0?.image && <ChatImageAttachment image={message_0?.image} fileName={message_0?.fileName} isOwn={true} onPreview={() => openPreviewImage(message_0?.image)} onDownload={() => openAntiVirusScanPopup(message_0?.image, message_0?.fileName)} />}
                            {message_0?.file && <div className={`${message_0?.senderId != users?._id ? "bg-[#EEEEEE]" : "bg-[#354EF0]"} flex items-center pr-4 gap-10 cursor-pointer justify-between rounded-lg p-1`}>
                                <div className="flex items-center gap-2">
                                  <div className="text-[#009E36] font-poppins text-[14px] font-semibold p-1  rounded-md">
                                    <Image src={getExtensionImage(message_0?.file) || "/Images/pdf.png"} alt="image" />
                                  </div>
                                  <div className={`${message_0?.senderId != users?._id ? "text-black" : "text-white"} text-[14px] font-medium font-poppins`}>
                                    {message_0?.fileName}
                                  </div>
                                </div>
                                <div onClick={() => openAntiVirusScanPopup(message_0?.file, message_0?.fileName)} className="bg-[#1430E9] p-1.5 rounded-md">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M17.5003 15.8335H2.50033C2.27931 15.8335 2.06735 15.9213 1.91107 16.0776C1.75479 16.2339 1.66699 16.4458 1.66699 16.6668C1.66699 16.8878 1.75479 17.0998 1.91107 17.2561C2.06735 17.4124 2.27931 17.5002 2.50033 17.5002H17.5003C17.7213 17.5002 17.9333 17.4124 18.0896 17.2561C18.2459 17.0998 18.3337 16.8878 18.3337 16.6668C18.3337 16.4458 18.2459 16.2339 18.0896 16.0776C17.9333 15.9213 17.7213 15.8335 17.5003 15.8335Z" fill="white" />
                                    <path d="M10.0005 1.6665C9.77947 1.6665 9.5675 1.7543 9.41122 1.91058C9.25494 2.06686 9.16715 2.27882 9.16715 2.49984V11.3248L6.42548 8.57484C6.26856 8.41792 6.05573 8.32976 5.83381 8.32976C5.6119 8.32976 5.39907 8.41792 5.24215 8.57484C5.08523 8.73176 4.99707 8.94459 4.99707 9.1665C4.99707 9.38842 5.08523 9.60125 5.24215 9.75817L9.40881 13.9248C9.48628 14.0029 9.57845 14.0649 9.68 14.1072C9.78155 14.1496 9.89047 14.1713 10.0005 14.1713C10.1105 14.1713 10.2194 14.1496 10.321 14.1072C10.4225 14.0649 10.5147 14.0029 10.5921 13.9248L14.7588 9.75817C14.8365 9.68047 14.8981 9.58823 14.9402 9.48671C14.9822 9.38519 15.0039 9.27639 15.0039 9.1665C15.0039 9.05662 14.9822 8.94781 14.9402 8.8463C14.8981 8.74478 14.8365 8.65254 14.7588 8.57484C14.6811 8.49714 14.5889 8.4355 14.4874 8.39345C14.3858 8.3514 14.277 8.32976 14.1671 8.32976C14.0573 8.32976 13.9485 8.3514 13.8469 8.39345C13.7454 8.4355 13.6532 8.49714 13.5755 8.57484L10.8338 11.3248V2.49984C10.8338 2.27882 10.746 2.06686 10.5897 1.91058C10.4335 1.7543 10.2215 1.6665 10.0005 1.6665Z" fill="white" />
                                  </svg>
                                </div>
                              </div>}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={`text-neutral-400  text-xs flex ${message_0?.senderId !== users?._id ? "justify-start" : "justify-end"} pl-12 py-1 font-medium  font-poppins`}>
                      {convertTo24HourFormat(message_0?.createdAt)}
                    </div>
                  </div> : <div className="w-full flex justify-end" ref={index === messages?.length - 1 ? lastMessageRef : null}>
                    <div className="flex flex-col">
                      <div className="cursor-pointer pt-2 bg-blue-600 rounded-lg flex-col justify-center items-center  gap-2 inline-flex">
                        <ChatImagePreview image={message_0?.image} />
                        <div className="self-stretch px-4 py-2  rounded-xl justify-start items-start gap-2.5 inline-flex">
                          <div className="text-white text-sm font-medium font-poppins">
                            {message_0?.text}
                          </div>
                        </div>
                      </div>
                      <div className={`text-neutral-400  text-xs flex ${message_0?.senderId !== users?._id ? "justify-start" : "justify-end"}  py-1 font-medium  font-poppins`}>
                        {convertTo24HourFormat(message_0?.createdAt)}
                      </div>
                    </div>
                  </div>)}

            {fileUploadingLoader && <div className="my-6 w-full">
                <div className="w-full sm:w-[40%] mx-auto">
                  <ImageLoader />
                </div>
              </div>}

            {suggestion && <div className="mt-auto">
                <div className="justify-center w-full items-start gap-2 sm:gap-4 flex flex-wrap mb-3">
                  {suggestionsList?.length > 0 && suggestionsList?.map((suggest, index_0) => <div key={index_0} className="px-3 sm:px-4 py-2 text-black cursor-pointer hover:bg-blue-600 hover:text-white rounded-xl border border-blue-600 justify-start items-start gap-2.5 flex">
                        <div className="text-xs font-medium font-poppins" onClick={() => setMessageFromSuggest(suggest?.text)}>
                          {suggest.text}
                        </div>
                      </div>)}
                </div>
              </div>}
            {!fileUploadingLoader && !message && showPredefinedMessage && <div className="my-2 w-full mt-auto">
                <div className="flex-wrap flex justify-center gap-2 px-2">
                  <div className="flex-wrap flex justify-center gap-2 sm:gap-3">
                    <div onClick={() => handleInputChange({
                  target: {
                    value: `Requesting information on ${product && product?.openfda?.brand_name}.`
                  }
                })} className="text-xs sm:text-sm border border-[#354EF0] px-2 sm:px-3 py-1.5 rounded-md h-max cursor-pointer text-center">Requesting information on {product && product?.openfda?.brand_name}.</div>
                    <div onClick={() => handleInputChange({
                  target: {
                    value: `Requesting samples of ${product && product?.openfda?.brand_name}.`
                  }
                })} className="text-xs sm:text-sm border border-[#354EF0] px-2 sm:px-3 py-1.5 rounded-md h-max cursor-pointer text-center">Requesting samples of {product && product?.openfda?.brand_name}.</div>
                    <div onClick={() => handleInputChange({
                  target: {
                    value: `Are you available for a call regarding ${product && product?.openfda?.brand_name}?`
                  }
                })} className="text-xs sm:text-sm border border-[#354EF0] px-2 sm:px-3 py-1.5 rounded-md h-max cursor-pointer text-center">Are you available for a call?</div>
                  </div>
                </div>
              </div>}
          </div>

          {/* Fixed Bottom Input */}
          <div className="py-3 sm:py-4 w-full px-4 border-t border-gray-200 flex-shrink-0 bg-white flex flex-col gap-3">
            {selectedFile && !fileUploadingLoader && <div className="w-full sm:w-[50%] my-1">
                <div className="text-[12px] font-poppins font-medium text-[#8E8E8E]">
                  Attachments
                </div>
                <div className="bg-[#354EF0] flex items-center pr-2 sm:pr-4 gap-2 sm:gap-4 mt-2 cursor-pointer justify-between rounded-lg p-1">
                  <div className="flex items-center gap-2 min-w-0 flex-1">
                    <div className="text-[#009E36] font-poppins text-[14px] font-semibold p-1 rounded-md flex-shrink-0">
                      {getFileTypeFromUrl(selectedFile?.name) === "image" && <img src={URL.createObjectURL(selectedFile)} height={40} width={40} className="rounded" />}
                      {getFileTypeFromUrl(selectedFile?.name) === "file" && <Image src={getExtensionImage(selectedFile?.name) || "/Images/pdf.png"} height={40} width={40} alt="image" />}
                    </div>
                    <div className="text-white text-xs sm:text-sm font-medium font-poppins truncate">
                      {selectedFile?.name}
                    </div>
                  </div>
                  <div onClick={() => setSelectedFile(null)} className="bg-[#1430E9] p-1.5 rounded-md flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path fillRule="evenodd" clipRule="evenodd" d="M1.00073 13.5864C0.610233 13.977 0.610293 14.6101 1.00085 15.0006C1.39141 15.3911 2.02457 15.3911 2.41506 15.0005L8.0003 9.41427L13.586 15C13.9765 15.3905 14.6097 15.3905 15.0002 15C15.3907 14.6095 15.3907 13.9763 15.0002 13.5858L9.4144 7.99997L14.9998 2.41359C15.3902 2.02303 15.3902 1.38987 14.9996 0.999381C14.6091 0.608881 13.9759 0.60894 13.5854 0.9995L8.0001 6.58577L2.41438 0.999981C2.02386 0.60946 1.39069 0.60946 1.00017 0.999981C0.609643 1.39051 0.609643 2.02367 1.00017 2.4142L6.5861 8.00007L1.00073 13.5864Z" fill="white" />
                    </svg>
                  </div>
                </div>
              </div>}
            <EmojiInput selectedImage={selectedFile} HandleUploadFiles={handleSelectFile} message={message} handleInputChange={handleInputChange} sendMessage={sendMessage} />
          </div>
          {isAntiVirusScanOpen && fileToDownload?.file?.length > 0 && <AntiVirusScan fileToDownload={fileToDownload} setFileToDownload={setFileToDownload} onClose={closeAntiVirusScanPopup} />}
          {isPreviewImageOpen && previewImage && <PreviewImagePopup previewImage={previewImage} onClose={closePreviewImage} />}
        </div>
      </div>
    </>;
  return createPortal(modal, document.body);
};
export default SendMessage;